var attrHide, attrShow, axHide, axShow, axToggleVisiblityState, overwritePlaceholder, setPlaceholderState, togglePlaceholderState;

attrShow = {
  'aria-hidden': false,
  'tabindex': 0
};

attrHide = {
  'aria-hidden': true,
  'tabindex': -1
};


/**
 * Toggle visibility class on adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

setPlaceholderState = function($input, action) {
  var $placeholder;
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if ($input.attr('placeholder')) {
    action = 'hide';
  }
  $placeholder = $input.siblings('.ls-flex-placeholder');
  if (!($placeholder != null ? $placeholder.length : void 0)) {
    return;
  }
  switch (action) {
    case 'hide':
      $placeholder.addClass('isHidden');
      break;
    case 'show':
      $placeholder.removeClass('isHidden');
      break;
    default:
      $placeholder.toggleClass('isHidden');
  }
};

overwritePlaceholder = function($input, text) {
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if (text == null) {
    text = $input.val();
  }
  return $input.siblings('.ls-flex-placeholder').text(text);
};


/**
 * Wrapper to toggle visibility of adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

togglePlaceholderState = function($input, action) {
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if (action) {
    setPlaceholderState($input, action);
  } else {
    if ($input.val() === '') {
      setPlaceholderState($input, 'show');
    } else {
      setPlaceholderState($input, 'hide');
    }
  }
};


/**
 * AX - Function to toggle visibility of jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axToggleVisiblityState = function($el, cb) {
  var attr, isHidden;
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  isHidden = $el.attr('aria-hidden') === 'true';
  attr = isHidden ? attrShow : attrHide;
  $el.attr(attr);
  if (typeof cb === "function") {
    cb();
  }
};


/**
 * AX - Function to hide jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axHide = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrHide);
  if (typeof cb === "function") {
    cb();
  }
};


/**
 * AX - Function to show jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axShow = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrShow);
  if (typeof cb === "function") {
    cb();
  }
};

module.exports = {
  ax: {
    show: axShow,
    hide: axHide,
    toggleVisibility: axToggleVisiblityState
  },
  attrShow: attrShow,
  attrHide: attrHide,
  placeholderState: {
    overwrite: overwritePlaceholder,
    set: setPlaceholderState,
    toggle: togglePlaceholderState
  }
};

